import React from 'react';

import clsx from 'clsx';
import { FormikErrors } from 'formik';
import { Grid, TextField, makeStyles } from '@material-ui/core';
import { GenericFormItem } from 'skyone-lib/lib/GenericForm/interfaces';
import styles from './styles';

const useStyles = makeStyles(styles);

interface DynamicTextFieldProps extends GenericFormItem {
  value: string;
  setFieldValue: (field: string, value: any) => void;
  errors?: FormikErrors<any>;
}

const DynamicTextField = ({
  value,
  label,
  setFieldValue,
  stateKey,
  gridXs,
  errors,
}: DynamicTextFieldProps) => {
  const classes = useStyles();

  return (
    <Grid item xs={gridXs}>
      <TextField
        className={clsx({
          [classes.dynamicField]: !!value.length,
        })}
        multiline
        value={value}
        fullWidth
        variant="outlined"
        label={label}
        onChange={e => {
          setFieldValue(stateKey, e.target.value);
        }}
        error={!!errors?.[stateKey]}
        helperText={errors?.[stateKey]}
      />
    </Grid>
  );
};

export default DynamicTextField;
